import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-limit',
  templateUrl: './limit.component.html',
  styleUrls: ['./limit.component.scss']
})
export class LimitComponent implements OnInit {
  @Input()
  userLimit: number;

  @Output()
  private limitFormOutput = new EventEmitter<any>();

  public limitForm: FormGroup;

  constructor() {}

  ngOnInit() {
    // Create limit form
    this.limitForm = new FormGroup({
      limit: new FormControl(this.userLimit || 1000, [
        Validators.required,
        Validators.min(1),
        Validators.max(1000)
      ])
    });

    // Emit limitForm as Output to handle changes in parent
    this.limitFormOutput.emit(this.limitForm);
  }

  preventDecimals(value) {
    this.limitForm.patchValue({
      limit: Math.round(value)
    });
  }
}
